import * as S from '../../pages/HomePageWithData.styles';

import React from 'react';
import {Link} from 'react-router-dom';
import config from '../../config';
import docUrl from '../../util/doc_urls';
import * as urls from '../../util/urls';
import makeComp from '../../util/profiler';
import DocsIcon from '../../assets/ic-docs.svg';
import GalleryIcon from '../../assets/ic-gallery.svg';
import ChatIcon from '../../assets/ic-chat.svg';
import {TargetBlank} from '../../util/links';

const ResourcesList: React.FC = makeComp(
  () => {
    return (
      <S.SidebarBlock>
        <S.SidebarBlockHeader>Resources</S.SidebarBlockHeader>
        <S.SidebarBlockLink>
          <S.SidebarBlockLinkIcon src={DocsIcon} />
          <a href={docUrl.root}>Documentation</a>
        </S.SidebarBlockLink>
        {!config.ENVIRONMENT_IS_PRIVATE && (
          <>
            <S.SidebarBlockLink>
              <S.SidebarBlockLinkIcon src={GalleryIcon} />
              <Link to={urls.reportGallery()}>Project gallery</Link>
            </S.SidebarBlockLink>
            <S.SidebarBlockLink>
              <S.SidebarBlockLinkIcon src={ChatIcon} />
              <TargetBlank href="http://wandb.me/slack">
                Slack forum
              </TargetBlank>
            </S.SidebarBlockLink>
          </>
        )}
      </S.SidebarBlock>
    );
  },
  {id: 'ResourcesList', memo: true}
);

export default ResourcesList;
